import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import { TriviaRankingHeader } from './Header';
import { TriviaRankingContent } from './Content';

const styles = () => ({
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});
class TriviaRanking extends PureComponent {
  static propTypes = {
    classes: PropTypes.shape({
      actions: PropTypes.string.isRequired,
    }).isRequired,
    answer: PropTypes.shape({
      earnedPoints: PropTypes.number.isRequired,
    }).isRequired,
    userRanking: PropTypes.shape({
      position: PropTypes.number.isRequired,
      of: PropTypes.number.isRequired,
    }).isRequired,
    actionClick: PropTypes.func.isRequired,
  };

  render() {
    const { classes, answer, userRanking, actionClick } = this.props;

    return (
      <div>
        <TriviaRankingHeader answer={answer} userRanking={userRanking} />
        <TriviaRankingContent userRanking={userRanking} />
        <CardActions className={classes.actions}>
          <Button size="small" color="primary" onClick={actionClick}>
            Got It
          </Button>
        </CardActions>
      </div>
    );
  }
}

export const TriviaRankingComponent = withStyles(styles)(TriviaRanking);
